import cn from 'clsx'

import { Copy } from 'shared-components'

import s from './Content.module.sass'

function Content({ project }: any) {
    const { contentHeading, content } = project

    if (!contentHeading && !content) return null

    return (
        <section className={s.Content}>
            <div className={cn(s.Cont, 'container')}>
                <div className={s.Title}>
                    <span className="smallCaps">Project Details</span>
                </div>
                <div className={s.Inner}>
                    {contentHeading && (
                        <h2
                            dangerouslySetInnerHTML={{
                                __html: contentHeading,
                            }}
                        />
                    )}
                    {content && (
                        <div className={s.Copy}>
                            <Copy copy={content} project />
                        </div>
                    )}
                </div>
            </div>
        </section>
    )
}

export default Content
